import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { ErrBanner } from '../../hooks/useApi';
import UserSection from './UserSection';
import CompanyMembers from './CompanyMembers';
import RoleManagement from '../RoleManagement/RoleManagement';
import './UserManagement.css';

const SUB_TABS = [
  { id: 'UserManagement', labelKey: 'userManagement.tabs.users' },
  { id: 'RoleManagement', labelKey: 'userManagement.tabs.roles' },
  { id: 'CompanyMembers', labelKey: 'userManagement.tabs.members' },
];

export default function UserManagement({ subPage = 'UserManagement' }) {
  const { t: tr } = useTranslation();
  const { canAccess, user } = useAuth();
  const isOwner = user && user.actor_type !== 'user';
  const [tab, setTab] = useState(subPage);

  useEffect(() => {
    setTab(subPage);
  }, [subPage]);

  if (!canAccess('roles')) {
    return (
      <div className="um-page">
        <ErrBanner msg={tr('userManagement.accessDenied')} />
      </div>
    );
  }

  return (
    <div className="um-page">
      <div className="page-header">
        <h2 className="page-title">{tr('userManagement.title')}</h2>
      </div>

      <div className="sub-tab-bar">
        {SUB_TABS
          .filter(t => {
            if (t.id === 'RoleManagement') {
              return canAccess('roles');
            }
            if (t.id === 'CompanyMembers') {
              // Cross-company members are an owner-only concept.
              return isOwner && canAccess('users');
            }
            return canAccess('users');
          })
          .map(t => (
            <button
              key={t.id}
              className={`sub-tab ${tab === t.id ? 'active' : ''}`}
              onClick={() => setTab(t.id)}
            >
              {tr(t.labelKey)}
            </button>
          ))}
      </div>

      <div className="tab-content" style={{ marginTop: '20px' }}>
        {tab === 'UserManagement' && <UserSection />}
        {tab === 'RoleManagement' && <RoleManagement />}
        {tab === 'CompanyMembers' && <CompanyMembers />}
      </div>
    </div>
  );
}
